import Validator from "./validator"

const Tags = {
    money({
        sign = "",
        amount,
        currency = ""
    }) {
        if (!Validator.isNotNull(amount) || !Validator.isNotNull(amount)) return ""
        return `${sign}${currency}${amount}`
    },
    precent({
        description = "",
        tax,
    }) {
        if (!Validator.isNotNull(tax) || !Validator.isNotNull(tax)) return ""
        return description != ""
            ? `description (${tax}%)`
            : `${tax}%`
    }
}

export default Tags